module.exports = __webpack_public_path__ + "static/media/marks-card-bg.ff648a85.png";